import {atomButtonColors, atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import {atomIconSizes} from '@s-ui/react-atom-icon'

export const DESIGNS = {
  BASIC: 'basic',
  COMPRESSED: 'compressed',
  HIGHLIGHTED: 'highlighted'
}

export const BUTTON_PROPS = {
  [DESIGNS.BASIC]: {
    color: atomButtonColors.NEUTRAL,
    design: atomButtonDesigns.FLAT,
    shape: atomButtonShapes.ROUNDED
  },
  [DESIGNS.COMPRESSED]: {
    color: atomButtonColors.PRIMARY,
    design: atomButtonDesigns.FLAT,
    iconSize: atomIconSizes.medium,
    shape: atomButtonShapes.CIRCULAR,
    size: atomButtonSizes.LARGE
  },
  [DESIGNS.HIGHLIGHTED]: {
    color: atomButtonColors.PRIMARY,
    design: atomButtonDesigns.OUTLINE,
    fullWidth: true,
    shape: atomButtonShapes.CIRCULAR
  }
}

export const PLACES = {
  ADS_LIST_SUBSCRIPTION: 'adsListSubscription',
  ADS_LIST: 'adsList',
  DEALERS_LIST: 'dealersList',
  FAVORITE_LIST: 'favoriteList',
  MAKES_DISTRIBUTOR: 'makesDistributor',
  MODELS_LIST: 'modelsList',
  PROFESSIONAL_STOCK_RENTING: 'professionalStockRenting',
  PROFESSIONAL_STOCK: 'professionalStock',
  TECHNICAL_DETAILS: 'technicalDetails',
  USER_ALERTS_MATCHES: 'userAlertsMatches'
}

export const ELEMENT_IDS = {
  BUTTON_PREFIX: 'search-sort-button-prefix',
  BUTTON_LABEL: 'search-sort-button-label'
}

export const SEARCH_USE_CASE_BY_PLACE = {
  [PLACES.ADS_LIST]: 'get_url_params_search_use_case',
  [PLACES.FAVORITE_LIST]: 'get_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK]: 'get_stock_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK_RENTING]: 'get_stock_url_params_search_use_case',
  [PLACES.ADS_LIST_SUBSCRIPTION]: 'get_url_params_search_use_case',
  [PLACES.TECHNICAL_DETAILS]: 'get_search_url_vehicles_use_case',
  [PLACES.USER_ALERTS_MATCHES]: 'get_url_params_search_use_case'
}
